/*
 * Search page "Blogs" tab fix (works alongside the USF app, independent of usf.js)
 *
 * 1) The Blogs tab asks Shopify for /search?q=...&view=usf-search. That request returns a mix of
 *    products, pages and articles, so products crowd out the blogs. This adds type=article,page
 *    so only blogs and pages come back.
 * 2) templates/search.usf-search.liquid returns 12 results per page and adds a hidden
 *    <!--USF_MORE--> marker when another page exists. This turns that marker into a "SHOW MORE"
 *    link (styled with the theme's blog_show_more_page class) that loads the next 12.
 */
(function () {
  'use strict';

  var TYPE = 'type=article,page';
  var MARKER = 'USF_MORE';

  // 1) Only ask Shopify for blogs and pages
  try {
    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      var args = Array.prototype.slice.call(arguments);
      if (typeof url === 'string' && /^\/search\?/.test(url) && /[?&]view=usf-search(&|$)/.test(url) && !/[?&]type=/.test(url)) {
        args[1] = url + '&' + TYPE;
      }
      return nativeOpen.apply(this, args);
    };
  } catch (e) {}

  // Everything below only applies to the search page
  if (!/\/search(\/|$)/.test(location.pathname)) return;

  // 2) "SHOW MORE" link for the Blogs tab
  var page = 1;
  var loading = false;

  function currentTerm() {
    var input = document.querySelector('.usf-sr-inputbox input[name="q"]');
    if (input && input.value) return input.value;
    return new URLSearchParams(location.search).get('q') || '';
  }

  function findMarker(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_COMMENT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim() === MARKER) return node;
    }
    return null;
  }

  function loadMore(wrap, btn) {
    if (loading) return;
    loading = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = 'LOADING...';
    var url = '/search?q=' + encodeURIComponent(currentTerm()) + '&view=usf-search&' + TYPE + '&page=' + (page + 1);
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var more = html.indexOf('<!--' + MARKER + '-->') > -1;
        html = html.replace('<!--' + MARKER + '-->', '');
        if (/content-grid-item/.test(html)) {
          wrap.insertAdjacentHTML('beforebegin', html);
        } else {
          more = false;
        }
        page += 1;
        if (more) {
          btn.removeAttribute('aria-disabled');
          btn.textContent = 'SHOW MORE';
        } else {
          wrap.parentNode && wrap.parentNode.removeChild(wrap);
        }
      })
      .catch(function () {
        btn.removeAttribute('aria-disabled');
        btn.textContent = 'SHOW MORE';
      })
      .then(function () {
        loading = false;
      });
  }

  function setup() {
    var box = document.getElementById('search_tab_content');
    if (!box) return;
    var marker = findMarker(box);
    if (!marker) return;

    var wrap = document.createElement('div');
    wrap.className = 'text-center usf-content-more';
    wrap.style.marginTop = '2rem';
    var btn = document.createElement('a');
    btn.href = '#';
    btn.className = 'blog_show_more_page';
    btn.textContent = 'SHOW MORE';
    wrap.appendChild(btn);
    marker.parentNode.replaceChild(wrap, marker);

    page = 1;
    loading = false;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      loadMore(wrap, btn);
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      setup();
    }, 0);
  }

  function start() {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    schedule();
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
